/* BD V1.5.16 candidate route-aware runtime loader. Existing modules stay unchanged; unnecessary page-level loads are skipped, duplicate static measurement loading is removed, and release identity is corrected after every module chain. */
(function(){
'use strict';
var VERSION='1.5.16-candidate';
var RELEASE='BD-EDUCATION-V1.5.16-CANDIDATE-2026-10-20';
var loaderScript=document.currentScript;
var MANIFEST={version:VERSION,release:RELEASE,state:'UNPUBLISHED_QA',singleWriterThemeId:'gid://shopify/OnlineStoreTheme/189584966018',evidenceRule:'NO_EVIDENCE_NO_GREEN'};
function markRelease(runtimeState){
  var html=document.documentElement;
  html.dataset.bdRelease=RELEASE;
  html.dataset.bdReleaseCandidate='true';
  html.dataset.bdRuntimeLoaderVersion=VERSION;
  html.dataset.bdRuntimeState=runtimeState||'UNKNOWN';
  var provenance=document.querySelector('meta[name="dasti-provenance"]');
  if(provenance){provenance.setAttribute('content','dasti-education-v1.5.16-candidate');provenance.dataset.runtimeCorrected='true';}
  var releaseMeta=document.querySelector('meta[name="dasti-release"]');
  if(releaseMeta){releaseMeta.setAttribute('content','V1.5.16-candidate');releaseMeta.dataset.runtimeCorrected='true';}
  window.__BD_EDUCATION_RELEASE_MANIFEST=MANIFEST;
}
function suppressStaticMeasurementDuplicate(){
  if(!loaderScript||!loaderScript.compareDocumentPosition)return;
  var removed=0;
  Array.prototype.slice.call(document.querySelectorAll('script[src*="b2b-analytics.js"]')).forEach(function(node){
    if(node===loaderScript||!node.parentNode)return;
    if((loaderScript.compareDocumentPosition(node)&Node.DOCUMENT_POSITION_FOLLOWING)!==0){
      node.parentNode.removeChild(node);
      removed+=1;
    }
  });
  document.documentElement.dataset.bdMeasurementStaticDuplicatesRemoved=String(removed);
}
markRelease('INITIAL');
suppressStaticMeasurementDuplicate();
if(window.__BD_EDUCATION_RUNTIME_LOADING){markRelease('ALREADY_LOADING');return;}
window.__BD_EDUCATION_RUNTIME_LOADING=true;
var source=loaderScript&&loaderScript.src;
if(!source){window.__BD_EDUCATION_RUNTIME_STATUS='NO_SOURCE';markRelease('NO_SOURCE');return;}
function asset(filename){return(window.BDThemeAssets&&window.BDThemeAssets[filename])||new URL(filename,source).href;}
var body=document.body;
var path=window.location.pathname||'';
var isProduct=body&&body.classList.contains('template-product');
var isCollection=body&&body.classList.contains('template-collection');
var isSearch=body&&body.classList.contains('template-search');
var isFunding=path==='/pages/finanzierung';
var hasExpertDirectory=!!document.querySelector('[data-expert-directory]');
var files;
if(isProduct||isCollection){
  files=['theme-v13-core.js','theme-v13-enhancements.js','theme-v14-enhancements.js','theme-v14-hardening.js'];
}else if(isSearch){
  files=['theme-v13-core.js','theme-v14-hardening.js'];
}else if(isFunding){
  files=['theme-v13-core.js'];
}else if(hasExpertDirectory){
  files=['theme-v12-base.js','theme-v14-hardening.js'];
}else{
  files=['theme-v12-base.js'];
}
window.__BD_EDUCATION_RUNTIME_PROFILE=isProduct?'product':isCollection?'collection':isSearch?'search':isFunding?'funding':hasExpertDirectory?'expert':'base';
function finish(state){
  markRelease(state);
  document.dispatchEvent(new CustomEvent('bd:runtime-ready',{detail:{version:VERSION,release:RELEASE,profile:window.__BD_EDUCATION_RUNTIME_PROFILE,state:state}}));
}
function load(i){
  if(i>=files.length){window.__BD_EDUCATION_RUNTIME_STATUS='LOADED:'+window.__BD_EDUCATION_RUNTIME_PROFILE;finish('LOADED');return;}
  var node=document.createElement('script');
  node.src=asset(files[i]);
  node.async=false;
  node.onload=function(){load(i+1);};
  node.onerror=function(){window.__BD_EDUCATION_RUNTIME_STATUS='LOAD_ERROR:'+files[i];finish('LOAD_ERROR:'+files[i]);};
  document.head.appendChild(node);
}
load(0);
})();
